import { sync } from 'vuex-pathify';

export default {
  computed: {
    isServiceIdentificationToolActive: sync('tools/toolStatus@isServiceIdentificationToolActive'),
  },
  methods: {
    identifyServiceFeatureInfo(identifyCallback) {
      return e => {
        const wmsProjectLayers = this.projectLayers.filter(layer => layer.visible && layer.service_type === 'wms');
        const data = wmsProjectLayers.map(layer => {
          const olLayer = this.getLayerById(layer.id, 'layers');
          const url = olLayer
            .getSource()
            .getFeatureInfoUrl(e.coordinate, this.map.getView().getResolution(), 'EPSG:3857', {
              INFO_FORMAT: 'text/html',
            });
          return {
            layer,
            infoUrl: url,
          };
        });
        identifyCallback({
          data,
          position: e.coordinate,
        });
      };
    },
    async toggleServiceIdentification(value = !this.isServiceIdentificationToolActive, callback) {
      value ? this.$root.$emit('deactivateAllTools') : this.deactivateToolHandler('serviceIdentification');
      this.isServiceIdentificationToolActive = value;
      this.dettachCursorMoveHandler();
      await this.$nextTick();
      if (value) {
        this.isIdentificationToolActive = false;
        this.activeTool = 'serviceIdentification';
        this.attachListener(
          'click',
          this.getIdentificationCallback({
            identifyCallback: callback,
            specialType: 'service',
          }),
          {
            type: 'on',
            cursor: 'pointer',
          }
        );
      }
    },
  },
  mounted() {
    this.$root.$off('serviceIdentification-action');
    this.$root.$on('serviceIdentification-action', this.toggleServiceIdentification);
  },
};
